import { useTranslation } from '@obvio/app'

import { JsonLd } from './JsonLd'
import { breadcrumbJsonLd } from '@/utils/jsonLd'
import { localizedUrl, toSiteLocale } from '@/utils/seo'

import type { ReactElement } from 'react'

type Crumb = {
  name: string
  /** Path without locale prefix. */
  path: string
}

type BreadcrumbsProps = {
  /** Crumbs after the home page, outermost first; the last one is the current page. */
  trail: Crumb[]
}

export function Breadcrumbs({ trail }: BreadcrumbsProps): ReactElement {
  const { locale, t } = useTranslation()
  const siteLocale = toSiteLocale(locale)

  return (
    <JsonLd
      id="breadcrumbs"
      data={breadcrumbJsonLd(
        [{ name: t('label.home'), path: '' }, ...trail].map(
          ({ name, path }) => ({
            name,
            url: localizedUrl(path, siteLocale),
          }),
        ),
      )}
    />
  )
}
